const React = require("react");
import * as actions from '../../actions/';
import { connect } from "react-redux";
import axios from 'axios';
const qs = require('querystring');
const NotificationSystem = require('react-notification-system');
export class ListButton extends React.Component {
    constructor() {
        super(...arguments);
        this._notificationSystem = null;
        this.editShopping = () => {
            var _a;
            let id = parseInt(this.props.id);
            if (this.props.shoppingList && this.props.IncrementList
                && this.props.DecrementList && this.props.ToggleLogin) {
                if (this.props.authenticated) {
                    if ([...this.props.shoppingList, this.props.id].length > 20 &&
                        this.props.shoppingList.indexOf(this.props.id) === -1) {
                        this._notificationSystem.addNotification({
                            message: "Exceed Shopping Cart Limit (Max 20 Items)",
                            level: "error"
                        });
                    }
                    else {
                        let ShoppingList = this.props.shoppingList.indexOf(id) === -1 ?
                            [...this.props.shoppingList, id].toString() :
                            this.props.shoppingList.filter((x) => { return x !== id; }).toString();
                        let antiForgery = (_a = document.querySelector('html').getAttribute('data-antiforgery')) !== null && _a !== void 0 ? _a : '';
                        axios.post('/Manage/SetShoppingList', qs.stringify({
                            ShoppingList
                        }), {
                            headers: {
                                "X-XSRF-TOKEN": antiForgery
                            }
                        })
                            .then(() => {
                            this.props.shoppingList.indexOf(id) === -1 ?
                                this.props.IncrementList(id) :
                                this.props.DecrementList(id);
                        });
                    }
                }
                else {
                    this.props.ToggleLogin();
                }
            }
        };
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    render() {
        return (React.createElement("div", { className: "list-button" },
            React.createElement(NotificationSystem, { ref: "notificationSystem" }),
            React.createElement("button", { className: "btn-primary btn-primary__filled", onClick: this.editShopping }, this.props.shoppingList && this.props.shoppingList.indexOf(parseInt(this.props.id)) === -1 ?
                "ADD TO LIST" :
                "REMOVE FROM LIST")));
    }
}
;
export const mapStateToProps = ({ shoppingList, authenticated, signInModal }, ownProps) => {
    return {
        shoppingList,
        authenticated
    };
};
export function mapDispatchToProps(dispatch) {
    return {
        DecrementList: (liquor) => dispatch(actions.DecrementList(liquor)),
        IncrementList: (liquor) => dispatch(actions.IncrementList(liquor)),
        ToggleLogin: () => dispatch(actions.ToggleLogin())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ListButton);
//# sourceMappingURL=list-button.js.map